<!-- static, m-0, border-0 and bg-transparent undo the browser's own dialog styles. -->
<dialog
  open
  class="crm-citation-card w-80 max-w-[calc(100vw-2rem)] p-3 flex flex-col gap-1.5 text-body-2 text-black static m-0 border-0 bg-transparent"
  [attr.aria-label]="label()"
>
  <div class="flex items-center gap-1.5 text-caption text-neutral-70">
    <span class="icon-12 shrink-0" [class]="icon()" aria-hidden="true"></span>
    <span class="font-medium text-neutral-80">{{ kind() }}</span>
    @if (date(); as date) {
      <span>· {{ date }}</span>
    }
  </div>

  @if (record(); as record) {
    @if (record.subject) {
      <p class="subtitle-2 text-black m-0 break-words">{{ record.subject }}</p>
    }
    @if (record.with; as name) {
      <p class="text-caption text-neutral-70 m-0">
        {{ 'iqboost.citation.with' | translate: { name } }}
      </p>
    }
    @if (record.description; as description) {
      <p class="crm-citation-description text-body-2 text-neutral-90 m-0">
        {{ description }}
      </p>
    }
  }

  <button
    type="button"
    class="self-start inline-flex items-center gap-1 p-0 mt-0.5 border-0 bg-transparent text-caption font-medium text-finserv-100 cursor-pointer hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-finserv-100 rounded"
    (click)="opened.emit()"
  >
    {{ 'iqboost.citation.open' | translate }}
    <span
      class="fa-icons icon-solid icon-10 icon-arrow-up-right-from-square"
      aria-hidden="true"
    ></span>
  </button>
</dialog>
